import React, { useEffect, useState } from "react";
import { ContentLayout } from "../../components/admin-panel/content-layout";
import { ArrowLeft } from "lucide-react";
import { Card } from "../../components/ui/card";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../components/ui/avatar";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import { Label } from "../../components/ui/label";
import DeleteModal from "../../components/deleteModal";
import Pagination from "../../components/Pagination";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import SuperAdminService from "../../services/superAdmin";
import UserService from "../../services/user/user";
import { toastError } from "../../components/ToastNotification";
import Loader from "../../assets/images/loader.gif";
import { useNavigate } from "react-router-dom";

const ViewAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const adminId = location.state?.id;
  const [data, setData] = useState();
  const [adminData, setAdminData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0); // This can be dynamic based on your data
  const [isLoading, setIsLoading] = useState(true);

  // Function to handle page change
  const handlePageChange = (page, event) => {
    event.preventDefault();
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      getAllUser();
    }
  };

  const getAdmin = async (userId) => {
    try {
      const response = await SuperAdminService?.getSingleAdmin(userId);
      if (response) {
        setData(response?.data?.data ? response?.data?.data : "");
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    }
  };

  const getAllUser = async () => {
    try {
      const response = await UserService?.getAllUser(
        adminId,
        currentPage,
        limit,
        ""
      );
      if (response) {
        setAdminData(response?.data?.data ? response?.data?.data : []);
        setTotalPages(Math.ceil(response.data?.totalUser / limit));
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (adminId) {
      getAdmin(adminId);
      getAllUser();
    }
  }, [adminId]);

  return (
    <ContentLayout>
      {isLoading ? (
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <img src={Loader} alt="Loader" className="w-20" />
        </div>
      ) : (
        <>
          <div className="max-w-2xl mb-10">
            <div
              className="flex items-center gap-2 cursor-pointer mb-6 text-neutral-400 hover:text-white transition-all duration-300 w-fit group"
              onClick={() => navigate(-1)}
            >
              <div className="p-1.5 rounded-full border border-neutral-800 bg-neutral-900/50 group-hover:bg-neutral-800/80 group-hover:border-neutral-700 transition-all">
                <ArrowLeft className="h-4 w-4" />
              </div>
              <span className="text-sm font-medium">Back</span>
            </div>
            <Card>
              <div className="grid gap-10">
                <h1 className="font-semibold text-xl">Admin Details</h1>
                <div className="grid gap-3">
                  <div className="flex gap-4 items-center">
                    <Label className="text-white w-36 text-base">Name</Label>
                    <span className="text-white/80 font-bold">:</span>
                    <h6 className="text-white/80">{data?.admin?.name}</h6>
                  </div>
                  <div className="flex gap-4 items-center">
                    <Label className="text-white w-36 text-base">Email</Label>
                    <span className="text-white/80 font-bold">:</span>
                    <h6 className="text-white/80">{data?.admin?.email}</h6>
                  </div>
                  <div className="flex gap-4 items-center">
                    <Label className="text-white w-36 text-base">
                      Phone Number
                    </Label>
                    <span className="text-white/80 font-bold">:</span>
                    <h6 className="text-white/80">
                      {data?.admin?.mobileNumber}
                    </h6>
                  </div>
                  <div className="flex gap-4 items-center">
                    <Label className="text-white w-36 text-base">Company</Label>
                    <span className="text-white/80 font-bold">:</span>
                    <h6 className="text-white/80">{data?.company?.name}</h6>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          <Card className="grid gap-5">
            <h1 className="font-semibold text-xl">User Details</h1>
            <div className="!border-border !border rounded-lg relative w-full overflow-auto">
              <Table>
                <TableHeader>
                  <TableRow className="bg-darkGray text-white">
                    <TableHead className="w-[100px] text-white">No.</TableHead>
                    <TableHead className="text-white">Name</TableHead>
                    <TableHead className="text-white">Phone Number</TableHead>
                    <TableHead className="text-white">Email</TableHead>
                    <TableHead className="text-white">Company</TableHead>
                    {/* <TableHead className="text-white">Password</TableHead> */}
                    {/* <TableHead className="w-14 text-center text-white">
                Action
              </TableHead> */}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {adminData.length > 0 ? adminData.map((adminData, index) => (
                    <TableRow key={adminData.adminData}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{adminData.name}</TableCell>
                      <TableCell>{adminData.mobileNumber}</TableCell>
                      <TableCell>{adminData.email}</TableCell>
                      <TableCell>{adminData?.company?.name}</TableCell>
                      {/* <TableCell>{"*".repeat(adminData.password.length)}</TableCell> */}
                      {/* <TableCell className="w-14">
                  <div className="flex items-center justify-center gap-2">
                    <DeleteModal />
                  </div>
                </TableCell> */}
                    </TableRow>
                  )) : (
                    <TableCell
                      colSpan={6}
                      className="text-center h-20 font-bold"
                    >
                      User Not Found
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </div>
            {adminData.length > 0 && (
              <div className="flex justify-end items-center">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  handlePageChange={handlePageChange}
                />
              </div>
            )}
          </Card>
        </>
      )}
    </ContentLayout>
  );
};

export default ViewAdmin;
